import React from 'react';

/* Campo de importe: se escribe con separador de miles (1.250.000) y devuelve el
   número pelado.

   La versión anterior hacía una sola cosa con lo que recibía: borrar todo lo que
   no fuera dígito. Eso está bien para lo que se tipea, pero los importes que
   vienen del servidor llegan como "175000.00" —MySQL devuelve los DECIMAL como
   texto—, y borrarle el punto daba "17500000". El campo mostraba cien veces el
   importe real, y ese número era el que se guardaba si apretabas Guardar.

   Por eso ahora se distingue de dónde viene el valor antes de interpretarlo. */

const soloDigitos = (v) => String(v ?? '').replace(/[^\d]/g, '');

/* Un punto con una o dos cifras atrás es un decimal del servidor ("175000.00").
   Un punto con tres cifras atrás es un separador de miles tipeado ("1.500").
   Es la única forma de leer bien los dos casos sin adivinar. */
const DECIMAL = /^-?\d+[.,]\d{1,2}$/;

function aNumero(v) {
  if (v === '' || v === null || v === undefined) return '';
  if (typeof v === 'number') return Number.isFinite(v) ? Math.round(v) : '';
  const s = String(v).trim();
  if (!s) return '';
  if (DECIMAL.test(s)) return Math.round(Number(s.replace(',', '.')));
  const d = soloDigitos(s);
  return d === '' ? '' : Number(d);
}

const conPuntos = (v) => {
  const n = aNumero(v);
  return n === '' ? '' : n.toLocaleString('es-AR');
};

export default function InputMonto({ value, onChange, placeholder = '0', ...props }) {
  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      value={conPuntos(value)}
      placeholder={placeholder}
      onChange={(e) => {
        const limpio = soloDigitos(e.target.value);
        onChange(limpio === '' ? '' : Number(limpio));
      }}
    />
  );
}

export { conPuntos, aNumero };
